import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { api } from "../lib/api";

export default function PublicLayout() {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    api.get("/profile").then((r) => setProfile(r.data)).catch(() => {});
  }, []);

  return (
    <div className="App min-h-screen flex flex-col bg-[#FDFBF7]">
      <Navbar />
      <main className="flex-1">
        <Outlet context={{ profile, setProfile }} />
      </main>
      <Footer profile={profile} />
    </div>
  );
}
